export const checkIsProd = () => process.env.GATSBY_ENV === "production"
